import React from 'react'

import formatPrice from '../../../../utilities/currency/formatPrice'
import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'

import yn from 'yn'
import _ from 'lodash'

const BkFlowStructuredSidebarMobileGrandTotal = props => {
	const {
		activeEnhancementData,
		activeRoomData,
		activeCurrencyData,
		hotelLabels,
	} = props
	const addTotals = (a, b) => a + b

	let crsCurrencyCode = null
	let crsCurrencySymbol = null
	let crsGrandTotal = null
	let reservationCurrencyCode = null
	let reservationCurrencySymbol = null
	let reservationGrandTotalData = []
	let reservationGrandTotal = null
	let reservationServicesTotalData = []
	let reservationServicesTotal = null

	if (activeRoomData) {
		if (
			activeRoomData &&
			activeRoomData[0][1] &&
			activeRoomData[0][1] &&
			_.get(activeRoomData[0][1], '[0].rates[0].total.currencyCode')
		) {
			crsCurrencyCode = activeRoomData[0][1][0].rates[0].total.currencyCode
			crsCurrencySymbol = getCurrencySymbol(crsCurrencyCode)

			reservationCurrencyCode = activeRoomData[0][1][0].rates[0].total.currencyCode
			reservationCurrencySymbol = getCurrencySymbol(reservationCurrencyCode)

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate &&
				activeCurrencyData.currencyCode
			) {
				reservationCurrencyCode = activeCurrencyData.currencyCode
				reservationCurrencySymbol = getCurrencySymbol(reservationCurrencyCode)
			}
		}

		for (const roomKey in activeRoomData) {
			const currentRoom = activeRoomData[roomKey]

			if (
				currentRoom &&
				currentRoom[1] &&
				_.get(currentRoom[1], '[0].rates[0].total.amountAfterTax')
			) {
				reservationGrandTotalData.push(currentRoom[1][0].rates[0].total.amountAfterTax)
			}
		}
	}

	if (activeEnhancementData) {
		for (const enhancementKey in activeEnhancementData) {
			const currentEnhancement = activeEnhancementData[enhancementKey]

			if (
				currentEnhancement.enhancementApiData &&
				currentEnhancement.enhancementApiData.price
			) {
				for (const enhancementPriceKey in currentEnhancement.enhancementApiData.price) {
					const currentEnhancementPrice = currentEnhancement.enhancementApiData.price[enhancementPriceKey]

					if (
						currentEnhancementPrice.base &&
						currentEnhancementPrice.base.amountAfterTax
					) {
						reservationServicesTotalData.push(currentEnhancementPrice.base.amountBeforeTax)
					}
				}
			}
		}

		reservationServicesTotal = reservationServicesTotalData.reduce(addTotals, 0)
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_INCLUDE_SERVICES_IN_TOTAL) &&
		reservationServicesTotal
	) {
		reservationGrandTotalData.push(reservationServicesTotal)
	}

	reservationGrandTotal = reservationGrandTotalData.reduce(addTotals, 0)

	if (String(activeCurrencyData.currencyCode) !== String(crsCurrencyCode)) {
		crsGrandTotal = reservationGrandTotalData.reduce(addTotals, 0)
	}

	// recalculate totals based on selected currency
	// and available exchange rates
	if (
		yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
		activeCurrencyData &&
		activeCurrencyData.exchangeRate &&
		activeCurrencyData.currencyCode
	) {
		if (reservationGrandTotal) {
			reservationGrandTotal = reservationGrandTotal * activeCurrencyData.exchangeRate
		}
	}

	return (
		reservationGrandTotal > 0 ?
			<div className="bk-flow-structured-sidebar__mobile-grand-total">
				<h6 className="total-value">
					<span className="label">{hotelLabels.grandTotal ? hotelLabels.grandTotal + ' ' : 'Grand Total '}</span>
					<span className="value">
            {reservationCurrencySymbol &&
              <span className="currency-symbol">{reservationCurrencySymbol}</span>
            }
	          {formatPrice(reservationGrandTotal,2)}
						{reservationCurrencyCode &&
							<span className="currency-code">&nbsp;{reservationCurrencyCode}</span>
						}
          </span>
				</h6>

				<p className="total-content">
	        <span className="label">({hotelLabels.includingTaxesFees ? hotelLabels.includingTaxesFees : 'Including Taxes & Fees'})</span>
					{ crsGrandTotal && crsGrandTotal > 0 &&
						<span className="value">
							{ crsCurrencySymbol &&
								<span className="currency-symbol">{crsCurrencySymbol}</span>
							}
							{ crsGrandTotal }
							{ crsCurrencyCode &&
								<span className="currency-code">&nbsp;{crsCurrencyCode}</span>
							}
		        </span>
					}
				</p>
			</div>
		:
			null
	)
}


export default BkFlowStructuredSidebarMobileGrandTotal


// WEBPACK FOOTER //
// ./src/components/structure/sidebar/mobile/BkFlowStructuredSidebarMobileGrandTotal.js